import {RouteConfig} from "vue-router";
import {RoleDeclare} from "@/enums/roledeclare";

const accountRoutes: Array<RouteConfig> = [
    {
        path: 'detail',
        component: () => import("@/modules/account/Information/index.vue"),
        name: "accountDetail",
        meta: { title: "Thông tin" }
    },
    {
        path: 'change-password',
        component: () => import("@/modules/account/ChangePassword/index.vue"),
        name: "changePass",
        meta: { title: "Đổi mật khẩu" }
    },
    // {
    //     path: 'member',
    //     component: () => import("@/modules/account/Member/index.vue"),
    //     name: "member",
    //     meta: { title: "Thành viên", role: RoleDeclare.ROLE_CAN_SEE_MEMBER }
    // },
    // {
    //     path: 'create-member',
    //     component: () => import("@/modules/account/Member/CreateMember/index.vue"),
    //     name: "createMember",
    //     meta: { title: "Tạo Thành viên", hidden: true }
    // },
    {
        path: 'notifications',
        component: () => import("@/modules/account/Notification/index.vue"),
        name: "notificationCustomers",
        meta: { title: "Thông báo của tôi" }
    },
    {
        path: 'notifications/:id',
        component: () => import("@/modules/account/Notification/Detail/index.vue"),
        name: "notificationDetailCustomers",
        props: true,
        meta: { title: "Danh sách thông báo", hidden: true }
    },
    {
        path: 'api-keys',
        component: () => import("@/modules/account/ApiKey/index.vue"),
        name: "apiKey",
        meta: { title: "Api Key", role: RoleDeclare.ROLE_CAN_SEE_API_KEY }
    },
]

export default accountRoutes;
